export { RecordModalContext } from '@app/providers/RecordModalProvider/RecordModalContext';
export {
  RecordModalProvider,
  useRecordModalContext,
} from '@app/providers/RecordModalProvider/RecordModalProvider.main';
